var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidayPackageRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 12.9806C27 14.7414 25.1884 12.1001 23.0145 12.3936C21.9354 12.0771 20.1159 12.9806 19.3913 13.5675C17.942 12.6871 16.4396 12.1001 14.3188 12.1001C12.1981 12.1001 10.6957 12.9806 9.6087 13.5675C8.15942 12.6871 6.4862 12.1455 5.26087 12.3936C2.36232 12.9806 2 14.7836 2 12.6871C2 8.31082 7.67755 5.05664 14.6812 5.05664C21.6848 5.05664 27 8.6043 27 12.9806Z",
    fill: "#AB0101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8184 1.82791C15.8184 0.999486 15.1468 0.327913 14.3184 0.327913C13.4899 0.327913 12.8184 0.999486 12.8184 1.82791H15.8184ZM15.8184 4.7627V1.82791H12.8184V4.7627H15.8184Z",
    fill: "#AB0101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8184 28.2413C12.8184 29.0698 13.4899 29.7413 14.3184 29.7413C15.1468 29.7413 15.8184 29.0698 15.8184 28.2413H12.8184ZM12.8184 26.4805V28.2413H15.8184V26.4805H12.8184Z",
    fill: "#AB0101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3184 24.1328V12.3937",
    stroke: "#AB0101",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68827 25.3062V26.8062H4.78062L4.35949 26.0021L5.68827 25.3062ZM0.670429 18.9587C0.286064 18.2248 0.569387 17.3183 1.30325 16.9339C2.03711 16.5496 2.94362 16.8329 3.32798 17.5667L0.670429 18.9587ZM22.2891 26.8062H5.68827V23.8062H22.2891V26.8062ZM4.35949 26.0021L0.670429 18.9587L3.32798 17.5667L7.01705 24.6102L4.35949 26.0021Z",
    fill: "#AB0101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3916 28.0405C21.8268 28.7454 21.6081 29.6696 20.9031 30.1048C20.1982 30.5399 19.274 30.3212 18.8388 29.6163L21.3916 28.0405ZM19.2177 24.5187L21.3916 28.0405L18.8388 29.6163L16.6649 26.0945L19.2177 24.5187Z",
    fill: "#AB0101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5113 28.2575C3.19604 29.0236 3.56151 29.9003 4.3276 30.2155C5.09369 30.5308 5.97031 30.1653 6.28557 29.3992L3.5113 28.2575ZM4.96058 24.7358L3.5113 28.2575L6.28557 29.3992L7.73485 25.8775L4.96058 24.7358Z",
    fill: "#AB0101"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4199 24.7189L10.1024 22.3711H4.17354",
    stroke: "#AB0101",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayPackageRed);
export default __webpack_public_path__ + "static/media/holiday-package-red.ab6af3436f913b6c8812cc50044477fd.svg";
export { ForwardRef as ReactComponent };